export const TRANSLATIONS = {
  RESEND: 'Resend code',
  RESEND_COUNTDOWN: 'Resend code in: ',
  RESEND_UNIT: 'sec',
}
